/**
 * 救援司机详情
 * 创建时间：2017-08-21
 * 创建人：baixx
 */
<template>				
<div class="wrapper-content fadeInRight animated tabBox" id="rescuedrive-Edit">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">	   	
		<div class="form-horizontal pt10px">
			<div class="col-sm-8">
				<div class="form-group">
					<label class="col-sm-2 control-label">绑定司机</label>
					<div class="col-sm-3">
						<input class="form-control" readonly v-model.trim="queryParams.nickname"/>
					</div> 
					<div class="col-sm-2">
						<!--<button type="button" v-if="isBinded==false" class="btn btn-primary" @click="startBind(status)">开始绑定</button>
	                    <button type="button" v-else="isBinded==true" class="btn btn-primary" @click="startBind(status)">重新绑定</button>-->
	                    <button type="button" v-if="form=='1' && permission.indexOf('rescueDriverList_bind') == -1" :disabled="!isStartBind" class="btn btn-primary" @click="startBind()">{{this.add=='add'?"开始绑定":"解除绑定"}}</button>
					    <button type="button" v-if="form=='2' && permission.indexOf('rescueDriverList_bind') == -1"  class="btn btn-primary" @click="startBind(bindStatus)">{{this.bindStatus==0?"开始绑定":"解除绑定"}}</button>
					</div> 
					<span class="col-sm-5 control-label gray t_left">注：(司机绑定微信后方可接单;初次绑定时需先保存司机的基本信息。)</span>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label red">*姓名</label>
					<div class="col-sm-4">
						<input class="form-control" v-model.trim="queryParams.driverName" maxlength="10">
					</div>  
					<label class="col-sm-2 control-label red">*联系电话</label>
					<div class="col-sm-4">
						<input class="form-control" v-model.trim="queryParams.driverPhone">
					</div> 
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">司机编号</label>
					<div class="col-sm-4">
						<input class="form-control" readonly v-model.trim="queryParams.id">
					</div>  
					<label v-show="add!='add'" class="col-sm-2 control-label">所属公司</label>
					<div v-show="add!='add'" class="col-sm-4">
						<input class="form-control" readonly v-model="queryParams.customerName">
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">备注</label>
						<div class="col-sm-10">
							<input class="form-control" v-model.trim="queryParams.memo">
						</div> 
					</div>
				</div>
			</div>	
			<div class="col-sm-4">
			    <label class="col-sm-3  control-label t_right">司机照片</label>
				<div class="col-sm-9">
					<div class="col-sm-12">
						<div class="uploadedImg t_right col-sm-3">
							<img v-if="queryParams.driverPhotourl==''" src="../../../assets/project/images/img_bg.jpg" class="img-responsive"/>
							<img v-if="queryParams.driverPhotourl!==''" :src="queryParams.driverPhotourl" class="img-responsive"/>
						</div>
						<vue-core-image-upload
							extensions="png,gif,jpeg,jpg"
							input-accept="image/jpg,image/jpeg,image/png"
							v-bind:crop="false"
							v-on:imageuploaded="imageuploadedBrand"						
							text=""
							inputOfFile="file"
							:url="picUrl"
							:headers="{'access-token':this.accesstoken}"
							v-bind:class="['upload-pic']"
							v-if="permission.indexOf('rescueDriverList_uploadImage') == -1"
							>
						</vue-core-image-upload>
						<span class="control-label gray t_left">请上传jpg、jpeg或png格式的图片</span>
				   </div>
				</div>
			</div>	
			<div class="form-group">
				<div class="col-sm-12 text-center pt20px">
					<button v-if="permission.indexOf('rescueDriverList_save') == -1" type="button" class="btn btn-primary" :disabled="isDown" @click="saveRescueOrder">保存</button>
				</div>
				</br>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-center pt20px">
				</div>
			</div>
		
			<div class="form-horizontal ibox-content pt50px">	
				<div v-show="form==2">
					<div class="form-group">
						<label class="col-sm-1 control-label">单号</label>
						<div class="col-sm-3">
							<input class="form-control" v-model.trim="queryParam.orderId">
						</div>
						<label class="col-sm-1 control-label">状态</label>
						<div class="col-sm-3">
							<select class="form-control" v-model="queryParam.status">
								<option v-for="option in rescurStatusList" v-bind:value="option.value">
								    {{ option.name }}
							    </option>
							</select>
						</div>
						<label class="col-sm-1 control-label">客户评价</label>
						<div class="col-sm-3">
							<select class="form-control" v-model="queryParam.evaluateStatus">
								<option v-bind:value="0">全部</option>
								<option v-bind:value="1">好评</option>
								<option v-bind:value="2">中评</option>
								<option v-bind:value="3">差评</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">接单开始时间</label>
						<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
							<datepicker v-model="queryParam.startTime" class="form-control" :options="localeOption" ref="orderTakingStartFrom"></datepicker>
							<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
						</div>
						<label class="col-sm-1 control-label">接单结束时间</label>
						<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
							<datepicker v-model="queryParam.endTime" class="form-control" :options="localeOption" ref="orderTakingEndFrom"></datepicker>
							<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
						</div>
					</div>
					<div class="form-group">
						<div class="col-sm-12 text-right">
							<button type="button"  class="btn btn-primary" :disabled="!validDates" @click="searchInfo">查询</button>
							<button type="button"  class="btn btn-primary" @click="resetQueryParams">重置</button>
						</div>
					</div>
					<div class="hr-line-dashed"></div>
					<!--表格开始-->
					<div class="location_table" style="overflow: hidden;">
				        <div style="overflow: auto;">
							<table style="min-width:1600px;" class="table table-striped table-bordered">
								<thead>
									<tr>
										<th rowspan="2">救援单号</th>
										<th rowspan="2">接单时间</th>
										<th rowspan="2">救援状态</th>
										<th rowspan="2">救援类型</th>
										<th rowspan="2">目的里程</th>
										<th colspan="4" class="text-center">被救援信息</th>
										<th v-show="levv!=3" colspan="2" class="text-center">评价信息</th>
										<th rowspan="2" v-if="orderList.length>0 && isShow()"></th>
									</tr>
									<tr>
										<th>车牌号</th>
										<th>车型</th>
										<th>颜色</th>
										<th>救援地址</th>
										<th v-show="levv!=3">客户</th>
										<th v-show="levv!=3">客服</th>
									</tr>
								</thead>
								<tbody>
									<tr  v-for="(fileInfo,index) in orderList" v-bind:key="index">
										<td>RS{{fileInfo.rescueOrderId}}</td>
										<td>{{fileInfo.orderTime}}</td>
										<td>{{fileInfo.rescueStageTxt}}</td>
										<td>{{fileInfo.rescueTypeTxt}}</td>
										<td>{{fileInfo.descMileage/1000}}km</td>
										<td>{{fileInfo.rescuedPlateNumber}}</td>
										<td>{{fileInfo.rescuedModel}}</td>
										<td>{{fileInfo.rescuedColor}}</td>
										<td>{{fileInfo.rescuedAddress}}</td>
										<td v-show="levv!=3" :class="evaluateStatusColor(fileInfo.evaluateStatus)">{{fileInfo.evaluateStatusTxt}}</td>
										<td v-show="levv!=3" :class="evaluateStatusColor(fileInfo.customerServiceEvaluateStatus)">{{fileInfo.customerServiceEvaluateStatusName}}</td>
										<td v-if="isShow()" class="text-center"><a v-show="fileInfo.rescueStage!=51 && fileInfo.rescueStage!=52 && fileInfo.rescueStage!=53" @click="detail(fileInfo.rescueOrderId)">详情</a></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<!--分页组件开始-->
		<pagination v-if="orderList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->
		</br>
		</div>	
		
		<main-modal ref="modalAdmin" size="normal" title="微信绑定" @close="closeAdmin">
			<div class="row">
				<div class="col-sm-12 text-center">
					<div>
						<img style="width: 150px; height: 150px;" alt="image" :src="wechatQr" />
						<p style="margin-top:20px;">请司机通过微信进行扫码关注</p>
					</div>
				</div>
			</div>
		</main-modal>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="cancleModalMsg">
			{{messageStr}}
			<div slot="footer">
				<button v-show="cancleMedium==true" @click="cancleModalMsg" class="btn btn-primary">取消</button>
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		
		<!--<sub-page :show="showSubPage" 
			:bigTitleMsg="title" 
			v-on:cancel="closeSubPage" 
			:scroll="scrollTop">
			
			<div slot="bodycontent">
				<page-rescue-service-order-edit-test :driverId="driverId" :orderId="orderId" v-on:toClose="handleClose">
				</page-rescue-service-order-edit-test>
			</div>
		</sub-page>-->
	</div>
</div>	
</template>
<script>
	import {DICTIONARY_MAP} from 'static/constant'
	import Pagination from 'components/common/Pagination'
	import { zh } from 'flatpickr/dist/l10n/zh';
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION,INFO_EXCEPTION } from 'static/message'
	//import SubPage from 'components/common/SubPage'
	import TabModal from 'components/common/TabModal'
	import {getDictionaryFromArray} from 'util/util'
	import classlist from 'util/classlist'
	import { maxLength } from 'vuelidate/lib/validators'
	import VueCoreImageUpload from 'vue-core-image-upload'
	import MainModal from 'components/common/MainModal'
	export default {
		name: "PageRescueDriverEdit",
		components: {
			Pagination,
			Datepicker,
			//SubPage,
			TabModal,
			VueCoreImageUpload,
			MainModal,
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["rescueDriverList"]?this.$store.state.permission.permission["rescueDriverList"]:[],
				loadingstatus:false,
				picUrl:process.env.API_INSURANCE_ROOT +"/rescue-api/photo/upload",
				pageInfo:{},	                                        //分页所需信息
				orderList: [], 		                                    //表格数据列表
				messageStr: "",					                        // 弹出框内容
				scrollTop: '',
				showSubPage: false,
				title: "救援记录详情",
				bindStatus:"",                                           //微信绑定状态
				driverId:"",                                              //司机ID
				orderId:"",                                              //救援单号
				add:"",                                                  //新增判断
				form:"",
				isDown:false,
				timer:"",						                         //判断用户扫描二维码的轮询器
				wechatQr:"",                                             //二维码图片
				isStartBind:false,
				customerId:this.$store.state.user.groupid,
				localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true
			    },
				queryParams:{	
					id:'',                                              //司机编号
					driverName:'',                                            //姓名
					driverPhone:'',                                           //手机
					nickname:'',                                        //绑定司机微信
					driverPhotourl:"",                                        //司机照片
					memo:"",                                            //备注
				},
				queryParam:{
					driverId:"",
					orderId:"",                                         // 单号
					startTime: "",							            // 接单起始时间
					endTime: "",                                        // 接单结束时间
					status:"",                                          // 状态
					evaluateStatus:"",                                  // 评价
					page_index: 1, 
				},
				driverPhotourl:"", 
				cancleMedium:false,
				rescurStatusList:[
				   {name:"全部",value:"0"},
				   {name:"救援中--司机已接单并前往现场中",value:"21"},
				   {name:"救援中--现场已抵达",value:"23"},
				   {name:"已完成--司机已完成",value:"31"},
				   {name:"已完成--客户已评价",value:"32"},
				   {name:"已撤单--客户主动取消",value:"41"},
				   {name:"已撤单--未能找到现场",value:"42"},
				   {name:"已撤单--救援录入重复",value:"43"},
				   {name:"已拒单--司机接单超时",value:"51"},
				   {name:"已拒单--司机拒绝接单",value:"52"},
				   {name:"已拒单--司机未能完成",value:"53"},
	               {name:"客服派单有误",value:"62"}]
			};
		},
		// 接收参数
		created(){
			//微信绑定判断
			this.bindStatus = this.$route.query.bindStatus;
			this.driverId = this.$route.query.id;
			this.add = this.$route.query.add;
			this.form = this.$route.query.form;
		},
		computed: {
			accesstoken:function(){
				return this.$store.state.user.accesstoken
			},
			levv(){
				return this.$store.state.user.levv
			},
			//起止时间是否合法
			validDates: function(){
				if(this.queryParam.startTime && this.queryParam.endTime && this.queryParam.startTime > this.queryParam.endTime){
					return false;
				} else {
					return true;
				}
			},
			status(){
				return this.$store.state.order.orderStatus
			},
		},
		watch:{
			status(){
				if(this.$route.query.id){
					this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/driver/wechat/check/'+this.$route.query.id)
					.then( res => {
						this.queryParams.nickname = res.body.data.wechatName
						if(res.body.data.bindStatus==1){
							this.bindStatus = 1
						}
						else{
							this.bindStatus = 0
						}
					}, res => {
						this.openModalMsg(res.body.message);
					})
				}
			}
		},
		beforeMount() {
			if((this.bindStatus==0 ||this.bindStatus==1) &&this.driverId){
				//获取救援司机详情
				this.getRescueEdit();
				//查询司机救援记录
				this.queryParam.driverId = this.driverId
			    this.getTableInfo();
			}
			else{
				//this.getCustomerName();
			}
		},
		methods: {
			//图片上传相关
			imageuploadedBrand(res){
				if(res.success){
					this.queryParams.driverPhotourl = process.env.PIC_PATH + res.data;
					//this.queryParams.driverPhotourl = 'http://weixin.didigps.com/uploadimages/rescuephoto/' + res.data;
					this.driverPhotourl = res.data;
				}else{
					this.tipContent = INFO_EXCEPTION.replace('{1}','上传图片');
					this.$refs.modal2.open();
				}
			},
			//获取所属公司
			getCustomerName(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT  + '/account/customers/'+this.customerId)
					.then( res => {
						if(res.body.success){
							this.queryParams.customerName = res.body.data.customerName;
						} else {
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.loadingstatus = false;
						this.openModalMsg(res.body.message);
					}).catch( res => {
						this.loadingstatus = false;
						this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
			//获取救援司机详情
			getRescueEdit(){          
				//this.$http.get('/mockjs/41/rescue-api/driver:driverId?driverId=')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/driver/'+this.driverId, {params: this.driverId})
					.then( res => {
						if(res.body.success){
							this.queryParams = res.body.data
							this.queryParams.id = 'DR'+res.body.data.id
							this.queryParams.driverPhotourl = res.body.data.driverPhotourl==''?'' : process.env.PIC_PATH + res.body.data.driverPhotourl
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			// 查询司机救援记录
			getTableInfo() { 
				let orderId = this.queryParam.orderId;
                orderId = orderId.replace(/[^0-9]/g,'');
                let status = this.queryParam.status;
                let evaluateStatus = this.queryParam.evaluateStatus;
                if(this.queryParam.status == 0){
					status = ''
				}
				if(this.queryParam.evaluateStatus == 0){
					evaluateStatus = ''
                }
                let parm = {
                    driverId:this.queryParam.driverId,
					orderId:orderId,                                        
					startTime:this.queryParam.startTime,							          
					endTime:this.queryParam.endTime,                                        
					status:status,                                          
					evaluateStatus:evaluateStatus,                                 
					page_index: this.queryParam.page_index, 
				}
				this.loadingstatus = true;
				//this.$http.get('/mockjs/41/rescue-api/driver/history/list?status=&orderId=&startTime=&evaluateStatus=&endTime=')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/driver/history/list', {params: parm})
					.then( res => {
						if(res.body.success){
							const resInfo = res.body.data;								
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.orderList = resInfo.list;
							this.loadingstatus = false;
						//	this.$store.dispatch('refreshRescueList', false)
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//判断是否显示详情
			isShow(){
				let arr = [];
				for(var i = 0; i < this.orderList.length; i++) {
					if(this.orderList[i].rescueStage ==51 ||this.orderList[i].rescueStage ==52 ||this.orderList[i].rescueStage ==53){
						arr.push(this.orderList[i].rescueStage)
					}
				}
				if(arr.length ==this.orderList.length){
					return false;
				}else{
					return true;
				}
				
			},
			evaluateStatusColor(evaluateStatus){
				if(evaluateStatus===1){
					return 'green'
				}else if(evaluateStatus===2){
					return 'orange'
				}else if(evaluateStatus===3){
					return 'red'
				}
			},
			evaluateStatus(evaluateStatus){
				if(evaluateStatus===1){
					return '好评'
				}else if(evaluateStatus===2){
					return '中评'
				}else if(evaluateStatus===3){
					return '差评'
				}
			},
			//开始绑定
			startBind(status){
				if(status == 0 || this.add == "add"){
					this.getCreateqr()
					this.$refs.modalAdmin.open();
					classlist.toggleScroll('close','#rescuedrive-Edit',this);
					//开始绑定
					const that = this;
					this.timer = setInterval(function(){
						//that.$http.get('/mockjs/41/rescue-api/driver/wechat/check:driverId?driverId=')
						that.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/driver/wechat/check/'+that.driverId)
							.then( res => {
								if(res.body.success && res.body.data.wechatName){
								// 已经绑定
									that.queryParams.nickname = res.body.data.wechatName
								//	that.wechatName = res.data.data;
									clearInterval(that.timer);
									if(that.queryParams.nickname){
										that.$refs.modalAdmin.close();
										that.bindStatus = 1
										that.add = ""
										that.cancleMedium = false;
										that.freshen();
										that.openModalMsg("微信绑定成功");
									}
								}
							}, res => {
								clearInterval(that.timer);
								that.cancleMedium = false;
								that.openModalMsg(res.body.message);
							})
					},1000)
				}else{
					//解除绑定
					this.cancleMedium = true;
					this.openModalMsg("是否解除微信绑定");
				}
			},
			//获取二维码
			getCreateqr(){                 
				//this.$http.get('/mockjs/41/driver/wechat/createqr:driverId?driverId=')
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/wechat/createqr/'+this.driverId)
				.then( res => {
					if(res.body.success){
						// 获取二维码成功
						this.wechatQr = res.body.data
					}
				}, res => {
					this.cancleMedium = false;
					this.openModalMsg(res.body.message);
				})
			},
			//关闭微信弹框
			closeAdmin(){
				classlist.toggleScroll('open','#rescuedrive-Edit',this);
				clearInterval(this.timer);
		    },
			//保存
			saveRescueOrder(){
			    let phone =/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(this.queryParams.driverPhone)
				if(!this.queryParams.driverName){
					this.cancleMedium = false;
					this.openModalMsg("姓名不能为空");
					return;
				}
				if(!phone){
					this.cancleMedium = false;
					this.openModalMsg("联系电话不正确");
					return;
				}
				this.loadingstatus = true;
				if(this.add == "add"){
					const para = {
						driverName: this.queryParams.driverName,
						driverPhone: this.queryParams.driverPhone,
						driverPhotourl: this.driverPhotourl,
						memo: this.queryParams.memo,
					}
					// this.$http.get('/mockjs/41/rescue-api/driver:driverId?photourl=&memo=&name=&phone=')
					this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/driver', para)
						.then(res => {
							if(res.body.success) {
								this.cancleMedium = false;
								this.freshen();
								this.openModalMsg("信息保存成功,点击开始绑定，进行微信扫码关注后方可接单");
								this.isStartBind = true
								this.queryParams.id = res.body.data
								this.driverId = res.body.data
								this.isDown = true
							} else {
								this.cancleMedium = false;
								this.openModalMsg(res.data.message);
							}
							this.loadingstatus = false;
						}, res => {
							this.loadingstatus = false;
							this.cancleMedium = false;
							this.openModalMsg(res.data.message);
						}).catch(res => {
							this.loadingstatus = false;
							this.cancleMedium = false;
							this.openModalMsg(OPERATE_EXCEPTION);
				    }) 
				}else{
					 const para = {
						id: this.driverId, 
						driverName: this.queryParams.driverName,
						driverPhone: this.queryParams.driverPhone,
						driverPhotourl: this.driverPhotourl,
						memo: this.queryParams.memo,
					}
				    //this.$http.get('/mockjs/41/rescue/driver/'+this.driverId+'?driverId=20')
					this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/driver/'+this.driverId, para)
						.then(res => {
							this.cancleMedium = false;
							if(res.data.success) {
								this.freshen();
								this.openModalMsg("保存成功");
							} else {
								this.openModalMsg(res.data.message);
							}
							this.loadingstatus = false;
						}, res => {
							this.loadingstatus = false;
							this.cancleMedium = false;
							this.openModalMsg(res.data.message);
						}).catch(res => {
							this.loadingstatus = false;
							this.cancleMedium = false;
							this.openModalMsg(OPERATE_EXCEPTION);
				    }) 
				}
			   
			},
			//重置信息
			resetQueryParams:function(){
				this.$refs.orderTakingStartFrom.handleClear();
				this.$refs.orderTakingEndFrom.handleClear(); 
				this.queryParam = {
					driverId:this.driverId,
					orderId:"",                                     // 单号
					startTime: "",							    // 接单起始时间
					endTime: "",                                 // 接单结束时间
					status:"",                                          // 状态
					evaluateStatus:"",                                     // 评价	                       		   
					page_index: 1, 								    // 当前第几页
				}
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			//救援记录详情
			detail(id){
				const obj = {
					name:"RS"+id+'-司机救援详情',
					id:'PageRescueDriveOrderDetail',
					route:'/indexhome/rescueDriveOrderDetail' + id,
					No:'rescue' + id,
						params:{id: id,from:0,driverId:this.driverId}
					}
					this.$router.push({path:'/indexhome/rescueDriveOrderDetail' + id,query:obj.params});
					this.$store.dispatch('addTab',obj);
			//	this.orderId = orderId;
			//	this.showSubPage = true;
			//	classlist.toggleScroll('close','#rescuedrive-Edit',this);
			},
			//closeSubPage(){
			//	this.showSubPage = false;
			//	classlist.toggleScroll('open','#rescuedrive-Edit',this);
			//},
			//handleClose() { //点击关闭
			//	this.showSubPage = false;
			//	this.freshen();
			//	classlist.toggleScroll('open','#rescuedrive-Edit',this);
			//},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        	},
        	//弹框确认
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        		classlist.toggleScroll('open','#rescuedrive-Edit',this);
        		if(this.messageStr=="是否解除微信绑定"){
        			//this.$http.post('/mockjs/41/rescue-api/driver/wechat/unbind:driverId?driverId=')
					this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/driver/wechat/unbind/'+this.driverId)
					.then( res => {
						if(res.body.success){
							// 解除绑定成功
							this.bindStatus = 0
							this.add = 'add'
							this.queryParams.nickname = ""
							this.cancleMedium = false;
							this.freshen();
							this.openModalMsg("解除绑定成功");
						}
					}, res => {
						this.openModalMsg(res.body.message);
					})
        		}
        	},
        	//弹框取消
        	cancleModalMsg(){
        		this.closeModal("modalMsg");
        		classlist.toggleScroll('open','#rescuedrive-Edit',this);
        	},
        	//绑定或解除后刷新
        	freshen(){
        			for(var i = 0; i < this.$store.state.home.tabList.length; i++) {
						 if(this.$store.state.home.tabList[i].id == "PageRescueDriverEdit"){
						 	//this.$store.dispatch('closeTab',i);
	                       // this.$router.push(this.$store.state.home.path);
	                        this.$store.dispatch('setorderstatus');
						}
					}
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        		classlist.toggleScroll('close','#rescuedrive-Edit',this);
        	}
		}
	}
</script>

<style scoped>
.upload-pic{
    	width:100px;
    	height:100px;
    	text-align:center;
    	font-size:16px;
    	line-height: 100px;
    	color:#46AC89; 
    	background-image:url(../../../assets/project/images/upload_pic.png);
    	background-size:contain;
    	background-position:center;
    	cursor:pointer;
    }
</style>


// WEBPACK FOOTER //
// PageRescueDriverEdit.vue?18bf00c0